export default __webpack_public_path__ + "static/media/slide25.83a48436.png";